import { Page } from '@/core/architecture'

import { ConsolePostsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePosts Page
 * Implemented as a practical sample.
 */
export const ConsolePosts: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePostsTemplate state={state} {...actions} />
}
